import { FC, useMemo, useRef, useEffect, useState } from "react";
import {
  Wrapper,
  Container,
  TitleWrapper,
  Title,
  AddBtn,
  EmptyImgSection,
  Image,
  ImageWrapper,
  IndImgWrapper,
  DeleteIcon,
} from "./StyledCoinImageUploader";
import { RootState } from "../../app/Store";
import {
  deleteThumbnail,
  resetThumbnail,
  uploadThumbnail,
} from "../../features/imageUploaderSlice";
import { useSelector, useDispatch } from "react-redux";
import { toggleNotificationVisibility } from "../../features/networkNotification";
import { NotificationType } from "../../Utility/InterFacesAndEnum";

interface ThumbnailProp {
  isShowBtn: boolean;
  isLottery: boolean;
}

const CoinThumbnailUploader: FC<ThumbnailProp> = ({ isShowBtn, isLottery }) => {
  const dispatch = useDispatch();

  const imageUploaderRef = useRef<HTMLInputElement>(null);

  const images = useSelector((state: RootState) => state.images.thumbnail);
  const uniqueImages = [...new Set(images)];

  // console.log(images,"Images")
  // console.log(uniqueImages,"unique")
  // console.log(uniqueImages)
  const [show, setShow] = useState(true);

  const deleteImg = (url: string) => {
    setShow(true);
    dispatch(
      deleteThumbnail({
        imgUrl: url,
      })
    );
  };

  useEffect(() => {
    if (images.length >= 1) {
      setShow(false);
      return;
    }
  }, [images]);

  useEffect(() => {
    return () => {
      dispatch(resetThumbnail());
    };
  }, []);

  let imagesView = useMemo(() => {
    if (images !== undefined && images !== null && images.length === 0) {
      return (
        <EmptyImgSection>
          <div>No Images Found</div>
        </EmptyImgSection>
      );
    } else {
      <EmptyImgSection>
        <div>No Images Found</div>
      </EmptyImgSection>;
    }
  }, [images]);

  let imageList: any = <></>;
  // console.log("Images :", images)

  if (images !== undefined && images !== null && images.length > 0) {
    imageList =
      images !== null &&
      uniqueImages.map((imgUrl: string) => {
        return (
          <IndImgWrapper>
            <DeleteIcon
              onClick={() => {
                deleteImg(imgUrl);
              }}
            >
              D
            </DeleteIcon>
            <Image src={imgUrl} alt={"Image"} key={imgUrl} />
          </IndImgWrapper>
        );
      });
  } else {
    imageList = (
      <EmptyImgSection>
        <div>No Image Found</div>
      </EmptyImgSection>
    );
  }

  const triggerImageUploader = () => {
    imageUploaderRef.current?.click();
  };

  const validateImage = (file: File) => {
    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    const maxFilenameLength = 100; // Maximum filename length

    if (file.name.length > maxFilenameLength) {
      return `Filename exceeds the maximum length of ${maxFilenameLength} characters.`;
    }
    if (validImageTypes.indexOf(file.type) === -1) {
      return "Invalid file type. Please select a JPEG, PNG, or JPG image.";
    }

    if (file.size > maxSize) {
      return "File size exceeds the limit of 5MB.";
    }

    return null; // Image is valid
  };

  const createUploadFileObj = (event) => {
    // uploadFile(event.target.files[0]);
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const validationError = validateImage(selectedFile);
      if (validationError) {
        dispatch(
          toggleNotificationVisibility({
            isVisible: true,
            status: NotificationType.error,
            message: validationError,
          })
        );
      } else {
        uploadFile(selectedFile);
      }
    }
    event.target.value = null;
  };

  // const createUploadFileObj = (event) => {
  //     uploadFile(event.target.files[0]);
  // }

  const uploadFile = (files: any) => {
    const formData = new FormData();
    formData.append("file", files);
    formData.append("documentName", files.name);
    dispatch(uploadThumbnail(formData));
  };

  return (
    <Wrapper>
      <Container>
        <input
          type={"file"}
          tabIndex={0}
          ref={imageUploaderRef}
          style={{ display: "none" }}
          onChange={(event) => {
            createUploadFileObj(event);
          }}
          accept="image/jpeg, image/png, image/jpg, image/tiff"
        />
        <TitleWrapper>
          <Title>{isLottery ? "Image" : "Thumbnail (200✖200)"}</Title>
          {isShowBtn && (
            <>
              {show && (
                <AddBtn onClick={triggerImageUploader}>
                  {isLottery ? "Add Image" : "Add Thumbnail"}
                </AddBtn>
              )}
            </>
          )}
        </TitleWrapper>
        <>
          {images !== undefined && images !== null && images.length === 0 ? (
            imagesView
          ) : (
            <ImageWrapper>{imageList}</ImageWrapper>
          )}
        </>
      </Container>
    </Wrapper>
  );
};

export default CoinThumbnailUploader;
